import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { Doctor } from '@shared/models/doctor';

export interface DoctorState {
	doctor: Doctor;
	reassignedDoctor: Doctor | null;
	isLicenseEditable: boolean;
}

export const createInitialState = (): DoctorState => ({
	doctor: {
		// @ts-expect-error - TODO: remove this comment and fix the type error
		Id: null,
		// @ts-expect-error - TODO: remove this comment and fix the type error
		Name: null,
		Licence: undefined
	},
	reassignedDoctor: null,
	isLicenseEditable: true
});

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'doctor' })
export class DoctorStore extends Store<DoctorState> {
	constructor() {
		super(createInitialState());
	}
}
